module.exports = __webpack_public_path__ + "assets/img/progress-circle-empty.svg";